import { render, staticRenderFns } from "./ClosingForHelpInfo.vue?vue&type=template&id=a64a4dca"
import script from "./ClosingForHelpInfo.vue?vue&type=script&lang=js"
export * from "./ClosingForHelpInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports